import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description"; // Example Icon
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ShieldIcon from "@mui/icons-material/Shield";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

const services = [
  {
    icon: <DescriptionIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "IEPF Claim",
    description:
      "Recover your unclaimed shares and dividends transferred to the Investor Education and Protection Fund (IEPF) with our expert guidance.",
    link: "#",
  },
  {
    icon: <AssignmentTurnedInIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "ROC Services",
    description:
      "Comprehensive ROC compliance solutions including company incorporation, annual filings, secretarial audits, and statutory reporting.",
    link: "#",
  },
  {
    icon: <AssignmentTurnedInIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "Duplicate Issue of Shares",
    description:
      "Assisting you in obtaining duplicate share certificates in case of loss, theft, damage, or misplacement of original documents.",
    link: "#",
  },
  {
    icon: <CompareArrowsIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "Transmission of Shares",
    description:
      "Facilitating smooth transfer of shares to legal heirs or nominees after the demise of a shareholder, ensuring rightful ownership.",
    link: "#",
  },
  {
    icon: <MonetizationOnIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "Unclaimed Mutual Funds",
    description:
      "Helping you trace and recover forgotten or unclaimed mutual fund investments, ensuring you reclaim what belongs to you.",
    link: "#",
  },
  {
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 40, color: "#F57C00" }} />,
    title: "Unclaimed Provident Funds",
    description:
      "Assisting individuals in recovering unclaimed provident fund (PF) amounts even if UAN or employer details are unavailable.",
    link: "#",
  },
];

const HomeServices: React.FC = () => {
  return (
    <Box
      sx={{
        padding: "40px 20px",
        backgroundColor: "#F9FAFC",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "40px",
          color: "#000",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        Our Services
      </Typography>

      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                padding: "20px",
                backgroundColor: "#FFFFFF",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                {service.icon}
              </Box>

              {/* Title */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "12px",
                  color: "#2C387E",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {service.title}
              </Typography>

              {/* Description */}
              <Typography
                variant="body2"
                sx={{
                  color: "#5A5A5A",
                  marginBottom: "16px",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {service.description}
              </Typography>

              {/* Read More */}
              <Button
                variant="text"
                sx={{
                  color: "#F57C00",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontFamily: "'Poppins', sans-serif",
                }}
                href={service.link}
              >
                Read More
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HomeServices;
